import { Controller } from "@hotwired/stimulus"

// Index checker form: live keyword count against the cap, and swapping the
// pincode choices when the marketplace changes.
export default class extends Controller {
  static targets = ["keywords", "count", "over", "submit", "marketplace"]
  static values = { max: Number, optionsUrl: String }

  connect() {
    this.count()
  }

  count() {
    const terms = new Set()
    this.keywordsTarget.value.split(/[\n,]/).forEach((t) => {
      const term = t.trim().toLowerCase().replace(/\s+/g, " ")
      if (term) terms.add(term)
    })
    const total = terms.size
    this.countTarget.textContent = total
    this.overTarget.hidden = total <= this.maxValue
    this.submitTarget.disabled = total > this.maxValue
  }

  marketplaceChanged() {
    const frame = document.getElementById("index_check_pincode")
    if (frame) frame.src = `${this.optionsUrlValue}?marketplace_id=${encodeURIComponent(this.marketplaceTarget.value)}`
  }
}
